module.exports = __webpack_public_path__ + "static/img/chooseCategoryIntro.8acc890.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/chooseCategoryIntro.png
// module id = ks1D
// module chunks = 3